import React, { useState, useEffect } from 'react'
import View from '@modul-connect/shared/components/atoms/view'
import { useAuth0 } from '@auth0/auth0-react'
import { ModalBase, WhitePaperBackground } from '@modul-connect/shared/components/molecules/modal/ModalBase'
import { customerServerUrl } from '@modul-connect/shared/config'
import { getAsync } from '../../../../../utils/ajax'
import AddNewAssetWithMaintenance from './addNewAssetWithMaintenance'
import AddMaintenanceToExistingAsset from './addMaintenanceToExistingAsset'
import { Tab, Tabs } from '@mui/material'
import { connect } from 'react-redux'




const defaultPlans = [{
  name: 'One-time event',
  value: 0
}, {
  name: 'Weekly',
  value: 7
}, {
  name: 'Every 2 weeks',
  value: 14
},
{
  name: 'Every 1 month',
  value: 30
},
{
  name: 'Every 2 months',
  value: 60
},
{
  name: 'Every 3 months',
  value: 90
},
{
  name: 'Every 6 months',
  value: 180
},
{
  name: 'Every 1 year',
  value: 360
},
{
  name: 'Every 2 years',
  value: 720
}]

export const getFrequencyOptions = (plans) => {
  if (!plans?.length) return defaultPlans.map(plan => { return { id: plan.name, value: plan.value, name: plan.name } })

  const options = defaultPlans.map((defaultPlan) => {
    return { id: defaultPlan.name, value: defaultPlan.value, name: defaultPlan.name }
  })
  return options?.sort((a, b) => a.value > b.value ? 1 : -1)
}


// TODO: get styling closer to figma, especially paper, title, box shadow
const AddMaintenanceModal = ({
  open,
  onClose,
  onSave,
  maintenance_plans,
  initCreateNewHomebase,
  homebaseInput,
  openUploadImage,
  imageUploaded,
  setModalForUploadingImage,
  saving,
  organisationNames,
  selected_organisations
}) => {

  const [vehiclesWithAssets, setVehicleWithAssets] = useState([])
  const [tokenState, setTokenState] = useState()
  const [tabValue, setTabValue] = useState(0)

  const { getAccessTokenSilently } = useAuth0()

  const fetchAssetsToMaintain = async (accessToken) => {
    const url = customerServerUrl() + '/asset-maintenance/existing-assets'
    await getAsync(accessToken, url).then(r => {
      setVehicleWithAssets(r?.data || [])
    })
  }

  useEffect(() => {
    getAccessTokenSilently().then((accessToken) => {
      fetchAssetsToMaintain(accessToken)
      setTokenState(accessToken)
    }
    )
  }, [open, getAccessTokenSilently, selected_organisations])


  // TODO: if can't save due to wrong inputs, tell user why
  return (
    <ModalBase onClose={onClose} open={open} title={'Maintenance'}>
      <View style={{ display: 'flex', alignItems: 'center', width: '100%', paddingBottom: '20px' }}>
        <Tabs value={tabValue} onChange={(_, value) => setTabValue(value)}>
          <Tab label='New equipment' ></Tab>
          <Tab label='Existing equipment' disabled={vehiclesWithAssets.length === 0}></Tab>
        </Tabs>
      </View>

      {tabValue == 0 ?
        <AddNewAssetWithMaintenance
          openUploadImage={openUploadImage}
          setModalForUploadingImage={setModalForUploadingImage}
          maintenance_plans={maintenance_plans}
          saving={saving}
          onSave={onSave}
          onClose={onClose}
          open={open}
          accessToken={tokenState}
          initCreateNewHomebase={initCreateNewHomebase}
          homebaseInput={homebaseInput}
          imageUploaded={imageUploaded}
          organisationNames={organisationNames}
        />
        :
        <AddMaintenanceToExistingAsset
          onSave={onSave}
          onClose={onClose}
          vehiclesWithAssets={vehiclesWithAssets}
          tokenState={tokenState}
        />
      }

    </ModalBase>
  )
}

export const InputSection = ({ children }) => {
  return (
    <WhitePaperBackground fullView>
      {children}
    </WhitePaperBackground>
  )
}
const mapStateToProps = props => props

export default connect(mapStateToProps)(AddMaintenanceModal)